<div *ngIf="isLoading; else content">
  <div class="border rounded bg-gray-50 lg:p-2 lg:m-2 p-1 m-1">
    <div class="card-content">
      <div class="mb-3">
        <app-content-shimmer height="80px"></app-content-shimmer>
      </div>
      <div class="mb-3">
        <app-content-shimmer height="180px"></app-content-shimmer>
      </div>
    </div>
  </div>
</div>

<ng-template #content>
  <ng-container *ngIf="availableModules.length === 0; else modulesList">
    <div class="border rounded bg-gray-50 lg:p-2 lg:m-2 p-1 m-1">
      <div>
        <span i18n>Dodatni moduli niso na voljo. Za več informacij nas kontaktirajte na </span>
        <a href="mailto:support@briefd.io">support&#64;briefd.io</a>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #modulesList>
  <div class="lg:p-2 lg:m-2 p-1 m-1">
    <div *ngFor="let group of moduleGroups; trackBy: trackByModuleType" class="module-group mb-6">
      <h3 class="font-bold text-lg mb-3">{{ group.displayName }}</h3>
      <div class="grid grid-cols-1 gap-4">
        <ng-container *ngFor="let module of group.packages; trackBy: trackByUuid">
          <div class="w-full">
            <app-module-package-card
              [modulePackage]="module"
              [isActive]="isModuleActive(module.uuid)"
              [activeModulePackage]="getActiveModule(module.uuid)"
              [hasConflict]="hasConflictingActiveModule(module)"
              [conflictingModule]="getConflictingActiveModule(module)"
              [isUpgrade]="isUpgrade(module)"
              [isDowngrade]="isDowngrade(module)"
              (moduleActivated)="onModuleActivated()"
              (moduleDeactivated)="onModuleDeactivated()">
            </app-module-package-card>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
